import * as angular from "angular";
import { MapHelperService } from "../map/map.helper";
import { House } from "../../models/house.model";

export class HouseHelperService {
    private mapHelperService: MapHelperService;

    constructor(MapHelperService: MapHelperService) {
        this.mapHelperService = MapHelperService;
    }

    urlAddressString(house?: House): string {
        if (house) {
            let addressString =
                (house.hname ? house.hname + " " : "") +
                (house.hnumber ? house.hnumber + " " : "") +
                (house.haddress ? house.haddress + ", " : "") +
                (house.hcity ? house.hcity + ", " : "") +
                (house.hstate ? house.hstate + ", " : "") +
                (house.hzipcode ? house.hzipcode + ", " : "");
            return addressString
                .replace(/null/g, "")
                .replace(/(^\s*,)|(,\s*$)/g, "")
                .trim()
                .replace(/\s/g, "+")
                .replace(",,", ",")
                .replace("&", "AND");
        }
    }

    locate(house: House, success: Function, failure: Function): any {
        return this.mapHelperService.locateAddress(house, success, failure);
    }

    reverseGeocode(
        latitude: number,
        longitude: number,
        success: Function,
        failure: Function
    ): any {
        return this.mapHelperService.reverseGeocode(
            latitude,
            longitude,
            success,
            failure
        );
    }

    addressDifferent(newAddress: House, oldAddress: House): boolean {
        return (
            newAddress.hunit != oldAddress.hunit ||
            newAddress.hname != oldAddress.hname ||
            newAddress.hnumber != oldAddress.hnumber ||
            newAddress.haddress != oldAddress.haddress ||
            newAddress.hcity != oldAddress.hcity ||
            newAddress.hstate != oldAddress.hstate ||
            newAddress.hzipcode != oldAddress.hzipcode ||
            newAddress.hprecinct != oldAddress.hprecinct
        );
    }
}

angular.module("house").service("HouseHelperService", HouseHelperService);
